module.exports = "/_next/static/images/gift-832b24cc.png";